import { RequireResetPasswordController } from './require-reset-password.controller';
import { IComponentOptions } from 'angular';
export const REQUIRE_RESET_PASSWORD_COMPONENT = "requireResetComponent";

export const requireResetComponentOptions : IComponentOptions = {
    controller: RequireResetPasswordController,
    template: require("./require-reset-password.html")
};


// WEBPACK FOOTER //
// ./app/require-reset-password/require-reset-password.component.ts